export interface UserRegistrationInitialValues {
  email: string
  name: string
  group: string
}

export const userRegistrationInitialValues: UserRegistrationInitialValues = {
  email: '',
  name: '',
  group: '',
}
